import { useApiClient } from '@/composables/useApiClient'
import type { ChatChannel } from '@/services/campaign/enums/chat-channel.enum'

import type { BotOption } from './interfaces'

export const useBotService = () => {
  const apiClient = useApiClient(true)

  // Sin canal el backend responde los bots de WhatsApp.
  const getBotOptions = async (channel?: ChatChannel): Promise<BotOption[]> => {
    try {
      const response = await apiClient.get<BotOption[]>('/bots/options', {
        params: { channel },
      })
      return response
    } catch (error) {
      throw error
    }
  }

  return {
    getBotOptions,
  }
}
